import { FC } from "react";
import { Button, makeStyles, Tooltip } from "@fluentui/react-components";
import { Chat20Regular, Document20Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  toggleButton: {
    minWidth: "36px",
    padding: "8px",
  },
});

export type ViewMode = "automation" | "chat";

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

export const ViewToggle: FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  const styles = useStyles();

  const handleToggle = () => {
    const newView = currentView === "automation" ? "chat" : "automation";
    onViewChange(newView);
  };

  const tooltipText = currentView === "automation" ? "Switch to AI Chat" : "Switch to Document Automation";

  const icon = currentView === "automation" ? <Chat20Regular /> : <Document20Regular />;

  return (
    <Tooltip content={tooltipText} relationship="description">
      <Button
        appearance="subtle"
        icon={icon}
        onClick={handleToggle}
        className={styles.toggleButton}
        aria-label={tooltipText}
      />
    </Tooltip>
  );
};
